<template>
    <div class="col-md-12 px-0 py-0">
        <div class="col-md-12 text-right text-success">
            <span style="font-size: 20px">Imagenes Registro</span>
        </div>
        <form action="" method="post" class="form-horizontal mt-5">
            <div class="form-group row">
                <label
                    class="col-md-3 form-control-label"
                    for="text-input"
                ></label>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger"></div>
                    <span v-if="allerrors.image" :class="['show-error']">{{
                        allerrors.image[0]
                    }}</span>
                    <a
                        v-if="image_path"
                        :href="image_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>

            <div class="form-group row">
                <div class="col-md-3"></div>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger-webp"></div>
                    <span v-if="allerrors.image_webp" :class="['show-error']">{{
                        allerrors.image_webp[0]
                    }}</span>
                    <a
                        v-if="image_webp_path"
                        :href="image_webp_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Alt image</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="text_image_alt"
                        class="form-control"
                        placeholder="Alt image"
                    />
                    <span
                        v-if="allerrors.text_image_alt"
                        :class="['show-error']"
                        >{{ allerrors.text_image_alt[0] }}</span
                    >
                </div>
            </div>

            <div class="form-group row">
                <label
                    class="col-md-3 form-control-label"
                    for="text-input"
                ></label>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger-logo"></div>
                    <span v-if="allerrors.image_logo" :class="['show-error']">{{
                        allerrors.image_logo[0]
                    }}</span>
                    <a
                        v-if="image_logo_path"
                        :href="image_logo_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>

            <div class="form-group row">
                <label
                    class="col-md-3 form-control-label"
                    for="text-input"
                ></label>
                <div class="col-md-9">
                    <div id="fine-uploader-manual-trigger-logo-webp"></div>
                    <span
                        v-if="allerrors.image_logo_webp"
                        :class="['show-error']"
                        >{{ allerrors.image_logo_webp[0] }}</span
                    >
                    <a
                        v-if="image_logo_webp_path"
                        :href="image_logo_webp_path"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Ver imagen</a
                    >
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Alt image logo</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="text_image_logo_alt"
                        class="form-control"
                        placeholder="Alt image logo"
                    />
                    <span
                        v-if="allerrors.text_image_logo_alt"
                        :class="['show-error']"
                        >{{ allerrors.text_image_logo_alt[0] }}</span
                    >
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" @click="update()" class="btn btn-primary">
                    Actualizar
                </button>
            </div>
        </form>
        <template-uploader></template-uploader>
        <template-uploader
            template_id="qq-template-manual-trigger-webp"
            text_button="Imagen webp"
        ></template-uploader>
        <template-uploader
            template_id="qq-template-manual-trigger-logo"
            text_button="Imagen logo"
        ></template-uploader>
        <template-uploader
            template_id="qq-template-manual-trigger-logo-webp"
            text_button="Imagen logo webp"
        ></template-uploader>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import qq from "fine-uploader";
import "fine-uploader/fine-uploader/fine-uploader-new.min.css";
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            image: null,
            text_image_alt: null,
            image_path: null,
            image_logo: null,
            text_image_logo_alt: null,
            image_logo_path: null,
            image_webp: null,
            image_webp_path: null,
            image_logo_webp: null,
            image_logo_webp_path: null,
            allerrors: {
                image: null,
                text_image_alt: null,
                image_logo: null,
                text_image_logo_alt: null,
                image_webp: null,
                image_logo_webp: null,
            },
            editor: ClassicEditor,
            editorConfig: {
                toolbar: ["bold", "italic", "underline"],
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/project-sections?type=imagenes%20de%20registro")
                .then(function (response) {
                    me.image = response.data.image;
                    me.image_path = response.data.image_path;
                    me.image_webp = response.data.image_webp;
                    me.image_webp_path = response.data.image_webp_path;
                    me.text_image_alt = response.data.text_image_alt;
                    me.image_logo = response.data.image_logo;
                    me.image_logo_path = response.data.image_logo_path;
                    me.image_logo_webp = response.data.image_logo_webp;
                    me.image_logo_webp_path =
                        response.data.image_logo_webp_path;
                    me.text_image_logo_alt = response.data.text_image_logo_alt;
                    me.clearError();
                })
                .catch(function (error) {});
        },

        update() {
            let me = this;
            if (me.validForm()) {
                axios
                    .put(
                        "/admin/project-section/project-image/update/" +
                            me.model_id,
                        {
                            image: me.image,
                            image_webp: me.image_webp,
                            text_image_alt: me.text_image_alt,
                            image_logo: me.image_logo,
                            image_logo_webp: me.image_logo_webp,
                            text_image_logo_alt: me.text_image_logo_alt,
                        }
                    )
                    .then(function (response) {
                        me.image_path = response.data.image_path;
                        me.image_logo_path = response.data.image_logo_path;
                        me.image_logo_webp_path =
                            response.data.image_logo_webp_path;
                        me.clearError();
                        me.showActionSuccess();
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.image) {
                me.allerrors.image = ["El campo imagen es obligatorio."];
                valid = false;
            }

            if (me.text_image_alt && me.text_image_alt.length > 190) {
                me.allerrors.text_image_alt = [
                    "El campo image alt debe tener máximo 190 caraccteres",
                ];
                valid = false;
            } else {
                me.allerrors.text_image_alt = null;
            }

            if (!me.image_logo) {
                me.allerrors.image_logo = [
                    "El campo imagen logo es obligatorio.",
                ];
                valid = false;
            }

            if (me.text_image_logo_alt && me.text_image_logo_alt.length > 190) {
                me.allerrors.text_image_logo_alt = [
                    "El campo imagen logo alt debe tener máximo 190 caraccteres",
                ];
                valid = false;
            } else {
                me.allerrors.text_image_logo_alt = null;
            }

            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                image: null,
                text_image_alt: null,
                image_logo: null,
                text_image_logo_alt: null,
                image_webp: null,
                image_logo_webp: null,
            };
        },
        showActionSuccess() {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: "Actualizacion exitosa!",
            });
        },
        getUploadImageUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/upload-image`;
        },
        getDeleteFileUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/delete-file`;
        },
    },
    mounted() {
        let me = this;
        me.getModel();
        new qq.FineUploader({
            element: document.getElementById("fine-uploader-manual-trigger"),
            request: {
                endpoint: this.getUploadImageUrl(),
            },
            template: "qq-template-manual-trigger",
            validation: {
                allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                sizeLimit: 20971520,
            },
            messages: {
                noFilesError: "Seleccione una imagen.",
            },
            callbacks: {
                onComplete: function (id, name, response) {
                    if (response.success) {
                        me.allerrors["image"] = null;
                        me.image = response.path;
                    } else {
                        me.allerrors["image"] = ["Error en la imagen"];
                    }
                },
            },
            multiple: false,
        });

        new qq.FineUploader({
            element: document.getElementById(
                "fine-uploader-manual-trigger-webp"
            ),
            request: {
                endpoint: this.getUploadImageUrl(),
            },
            template: "qq-template-manual-trigger-webp",
            validation: {
                allowedExtensions: ["webp"],
                sizeLimit: 20971520,
            },
            messages: {
                noFilesError: "Seleccione una imagen de tipo webp.",
            },
            callbacks: {
                onComplete: function (id, name, response) {
                    if (response.success) {
                        me.allerrors["image_webp"] = null;
                        me.image_webp = response.path;
                    } else {
                        me.allerrors["image_webp"] = ["Error en la imagen"];
                    }
                },
            },
            multiple: false,
        });

        new qq.FineUploader({
            element: document.getElementById(
                "fine-uploader-manual-trigger-logo"
            ),
            request: {
                endpoint: this.getUploadImageUrl(),
            },
            template: "qq-template-manual-trigger-logo",
            validation: {
                allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                itemLimit: 1,
                sizeLimit: 20971520,
            },
            messages: {
                noFilesError: "Seleccione una imagen.",
            },
            callbacks: {
                onComplete: function (id, name, response) {
                    if (response.success) {
                        me.allerrors["image_logo"] = null;
                        me.image_logo = response.path;
                    } else {
                        me.allerrors["image_logo"] = ["Error en la imagen"];
                    }
                },
            },
            multiple: false,
        });

        new qq.FineUploader({
            element: document.getElementById(
                "fine-uploader-manual-trigger-logo-webp"
            ),
            request: {
                endpoint: this.getUploadImageUrl(),
            },
            template: "qq-template-manual-trigger-logo-webp",
            validation: {
                allowedExtensions: ["webp"],
                itemLimit: 1,
                sizeLimit: 20971520,
            },
            messages: {
                noFilesError: "Seleccione una imagen de tipo webp.",
            },
            callbacks: {
                onComplete: function (id, name, response) {
                    if (response.success) {
                        me.allerrors["image_logo_webp"] = null;
                        me.image_logo_webp = response.path;
                    } else {
                        me.allerrors["image_logo_webp"] = [
                            "Error en la imagen",
                        ];
                    }
                },
            },
            multiple: false,
        });
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
